import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-enrolled',
  templateUrl: './student-enrolled.component.html',
  styleUrls: ['./student-enrolled.component.css']
})
export class StudentEnrolledComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  banner: any = {
    pagetitle: "Student Enrolled",
    bg_image: "assets/images/banner/bnr3.jpg",
    title: "Student Enrolled",
  }
}
